// React
import React from 'react';


// COMPONENTS

import PText from 'components/Primatives/PText';
import FlexColumn from 'components/Primatives/FlexColumn';
import FlexRow from 'components/Primatives/FlexRow';
import StyledRouteLink from 'components/Assests/StyledRouteLink';
import GlobalMaxWidth from 'components/Assests/GlobalMaxWidth';
import Strong from 'components/TextModifiers/Strong';

// UTILS
import { constants } from '../../constants';

/*

Props:

*/

const ServiceModulesBreadcrumbs = () => {
    const spacing = 10;
    const fontSize = '1.3em';
    const textColor = constants.color.primaryDark;
    const styles = {
        shardStyles : {
            marginRight: spacing, 
            fontSize: fontSize, 
            marginTop: 0, 
            marginBottom: 0,
            color: textColor
        }
    }
    
    return (
        <GlobalMaxWidth style={{width:'100%'}}>
            <FlexRow style={{backgroundColor: 'rgb(230, 230, 230)', flex: 'none', width: '100%', paddingLeft: '3vw', maxWidth: '93vw', alignItems: 'baseline' }}>
                <StyledRouteLink style={{ textDecoration: 'underline', ...styles.shardStyles}}
                    to={`/my-services`}
                >
                    My Services
                </StyledRouteLink>
                <PText style={{ ...styles.shardStyles}}> > </PText>
                <PText style={{ ...styles.shardStyles}}> <Strong>Service Dashboard</Strong></PText>
            </FlexRow>
        </GlobalMaxWidth>
    )
}




export default ServiceModulesBreadcrumbs;



// WEBPACK FOOTER //
// ./src/js/containers/ServiceContainer/ServiceModulesBreadcrumbs.jsx